import { useFormik } from "formik";
import React, { ReactElement, useEffect } from "react";

import { ApiValidationError } from "@/apis/errors";
import InputPassword from "@/components/atoms/inputForms/InputPassword";
import Yup from "@/utils/yup";

/**
 * シークレットページパスワードフォームの入力値
 */
export type PasswordParams = {
  password: string;
};

interface Props {
  password?: string;
  maxLength?: number;
  handlePageSecretSubmit: (input: PasswordParams) => Promise<void>;
  errors?: ApiValidationError;
}

/**
 * シークレットページパスワードフォーム
 */
export default function PageSecretPasswordForm({
  password: defaultPassword,
  maxLength = 255,
  handlePageSecretSubmit,
  errors,
}: Props) {
  useEffect(() => {
    if (errors) {
      formik.setErrors({
        password: errors.errors ? "パスワードが違います" : "",
      });
    }
  }, [errors]);

  const formik = useFormik({
    initialValues: {
      password: defaultPassword ?? "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .max(maxLength, `パスワードは${maxLength}文字以内に入力してください。`)
        .required("パスワードは必須入力です。"),
    }),
    onSubmit: async (values) => {
      await handlePageSecretSubmit({
        password: values.password,
      });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mt-10">
        <h2 className="p-4 text-xl text-center" style={{ fontWeight: 700 }}>
          このページにはパスワードが設定されています
        </h2>
      </div>
      <div className="flex flex-col gap-y-6 items-center px-4 mt-4">
        <div className="p-4">
          <div className="flex flex-col gap-y-6 items-center">
            <InputPassword
              id="password"
              placeholder="Password"
              className="min-w-[311px]"
              value={formik.values.password}
              onChange={formik.handleChange}
            />
          </div>
          {formik.errors.password && (
            <div className="text-left text-accent">
              {formik.errors.password}
            </div>
          )}
        </div>
        <div className="flex">
          <div className="flex-initial">
            <button
              type="submit"
              className="inline-block w-[200px] h-[40px] text-sm text-center text-white bg-primary hover:bg-primary-dark disabled:bg-gray-400 rounded md:transition-colors"
            >
              ページを閲覧
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

PageSecretPasswordForm.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
